import React, { useState, useEffect, useRef } from "react";
import GetAPI from "../../APICalls/GetAPI";
import PutAPI from "../../APICalls/PutAPI";
import PostAPI from "../../APICalls/PostAPI";
import AdminTabs from "../adminTabs";
import XpressHeaders from "./xpressHeader";
import XpressDeclineAlert from "./xpressDeclineAlert";
import XpressOrders from "./xpressOrders";
import NewOrderPopUp from "./xpressNewOrderPopUp";
import moment from "moment";
import XpressContainer from "./XpressContainer";
import OrderDetailsPopup from "./OrderDetailsPopup";
import { ThreeCircles } from "react-loader-spinner";
import "./xpress.css";
import XpressBookDaasPopup from "./xpressBookDaasPopup";

const Xpress = () => {
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [xpressData, setXpressData] = useState({ ALL: [], NEW: [] });
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [order, setOrder] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [searchOrderID, setSearchOrderID] = useState("");
  const [menuType, setMenuType] = useState("Breakfast");
  const [timeSlotOptions, setTimeSlotOptions] = useState([]);
  const [timeSlot, setTimeSlot] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [showConfirmBookDaas, setShowConfirmBookDaas] = useState(false);
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  let orderAPI, daasCreateOrderAPI;
  let environment = process.env.REACT_APP_NODE_ENV;
  if (environment === "PRODUCTION") {
    orderAPI = process.env.REACT_APP_PROD_ORDERAPI;
    daasCreateOrderAPI = process.env.REACT_APP_PROD_DAAS;
  } else {
    orderAPI = process.env.REACT_APP_DEV_ORDERAPI;
    daasCreateOrderAPI = process.env.REACT_APP_DEV_DAAS;
  }

  useEffect(() => {
    const fetchData = async () => {
      const completeURL = `${orderAPI}?type=XPRESS&deliveryDate=${date}`;
      try {
        const res = await GetAPI(completeURL);
        if (res.data.statusCode === 200) {
          const orders = res.data.body;
          setXpressData(orders);
        } else {
          setXpressData({ ALL: [], NEW: [] });
          console.error("Error occurred: ", res);
          alert("Failed to get xpress orders");
        }
      } catch (e) {
        setXpressData({ ALL: [], NEW: [] });
        console.error("Error occurred: ", e);
        alert("Failed to get xpress orders");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date]);

  useEffect(() => {
    if (showConfirmPopup === false && order !== null && !isPopupVisible) {
      handlePopUpClose({ reason: undefined, status: "ACCEPTED" });
    }
  }, [order]);

  const handlePopUpClose = ({ reason, status }) => {
    const dataToPut =
      reason !== undefined
        ? {
            orderID: order.orderID,
            status: status,
            reasonToReject: reason,
            cost: order.cost,
            paymentStatus: "REFUND",
          }
        : {
            orderID: order.orderID,
            status: status,
          };

    setLoading(true);

    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        if (status === "ACCEPTED") {
          handlePrint();
        } else {
          window.location.reload();
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        alert("Unable to update order status. Please try again later");
      });
  };

  const handleDateChange = (event) => {
    setLoading(true);
    setDate(event.target.value);
  };

  useEffect(() => {
    if (xpressData?.ALL?.length > 0) {
      setFilterData(xpressData?.ALL);
    } else {
      setFilterData([]);
    }
  }, [xpressData]);

  useEffect(() => {
    const sameMenu = (o) =>
      o.menuType?.toUpperCase() === menuType.toUpperCase() ||
      o.orderedItems?.some(
        (it) => it.menuType?.toUpperCase() === menuType.toUpperCase()
      );

    const deliverBySet = new Set(
      (xpressData.ALL || [])
        .filter(sameMenu)
        .map((o) => o.deliverBy)
        .filter(Boolean)
    );

    const options = Array.from(deliverBySet);
    setTimeSlotOptions(options);

    if (options.length && !options.includes(timeSlot)) {
      setTimeSlot(options[0]);
    } else if (!options.length && timeSlot) {
      setTimeSlot("");
    }
  }, [menuType, xpressData]);

  useEffect(() => {
    let data = xpressData.ALL || [];

    if (searchOrderID) {
      data = data.filter((o) => o.orderID.includes(searchOrderID));
    }

    if (menuType) {
      data = data.filter((o) =>
        o.menuType
          ? o.menuType.toUpperCase() === menuType.toUpperCase()
          : o.orderedItems?.some(
              (it) => it.menuType?.toUpperCase() === menuType.toUpperCase()
            )
      );
    }

    if (timeSlot) {
      data = data.filter((o) => o.deliverBy === timeSlot);
    }

    setFilterData(data);
  }, [searchOrderID, menuType, timeSlot, xpressData]);

  const handleBookDaas = () => {
    setIsPopupVisible(false);
    setShowConfirmBookDaas(true);
  };

  const handleDeliveryClick = (orderID, value) => {
    const dataToPut = {
      orderID: orderID,
      deliveryPartner: value,
    };
    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        setLoading(false);
        setOrder(null);
      })
      .catch((e) => {
        setLoading(false);
        alert("Failed  in changing delivery Status");
      });
  };

  const handleConfirmBookDaas = () => {
    setShowConfirmBookDaas(false);
    setLoading(true);
    const dataToPut = {
      orderID: order.orderID,
      status: "READY TO PICK",
    };
    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        setLoading(false);
        alert("Booked daas successfully!!!");
        setOrder(null);
        window.location.reload();
      })
      .catch((e) => {
        setLoading(false);
        alert("Failed  in changing delivery Status");
      });
  };

  const handleCancelDaas = () => {
    setShowConfirmBookDaas(false);
    setIsPopupVisible(false);
    setLoading(true);

    const completeDaasCancelUrl =
      daasCreateOrderAPI + "/cancel?orderId=" + order.orderID;
    const dataToPost = {
      cancellationReason: "",
    };

    PostAPI(completeDaasCancelUrl, dataToPost)
      .then((res) => {
        handleDeliveryClick(order.orderID, "N/A");
        alert("Successfully Cancelled Daas!!");
        window.location.reload();
      })
      .catch((e) => {
        setLoading(false);
        console.log("Failed to cancel Daas response = " + e);
        alert("Failed to cancel Daas, try manual cancellation");
      });
  };

  return (
    <AdminTabs>
      <div className="xpressContainer">
        {loading && (
          <div className="spinnerContainer">
            <div className="spinner">
              <ThreeCircles
                color="blue"
                height={110}
                width={110}
                ariaLabel="three-circles-rotating"
              />
            </div>
          </div>
        )}
        {isPopupVisible && order && (
          <OrderDetailsPopup
            isVisible={isPopupVisible}
            onClose={() => setIsPopupVisible(false)}
            order={order}
            handleBookDaas={handleBookDaas}
            handleCancelDaas={handleCancelDaas}
            handlePrint={handlePrint}
          />
        )}
        <XpressDeclineAlert
          showConfirmPopup={showConfirmPopup}
          handlePopUpClose={handlePopUpClose}
          setShowConfirmPopup={setShowConfirmPopup}
        />
        <XpressBookDaasPopup
          showConfirmBookDaasPopup={showConfirmBookDaas}
          handleConfirmBookDaas={handleConfirmBookDaas}
          setShowConfirmBookDaasPopup={setShowConfirmBookDaas}
        />

        <XpressHeaders />
        <div className="container">
          <XpressContainer
            totalOrders={xpressData?.ALL?.length}
            date={date}
            setSearchOrderID={setSearchOrderID}
            handleDateChange={handleDateChange}
            menuTypeValue={menuType}
            onMenuTypeChange={setMenuType}
            timeSlotOptions={timeSlotOptions}
            timeSlotValue={timeSlot}
            onTimeSlotChange={setTimeSlot}
          />
          <XpressOrders
            xpressOrders={filterData}
            setIsPopupVisible={setIsPopupVisible}
            setOrder={setOrder}
          />
        </div>
        {window.innerWidth > 768 ? (
          <NewOrderPopUp
            xpressData={xpressData}
            setShowConfirmPopup={setShowConfirmPopup}
            setOrder={setOrder}
            handlePopUpClose={handlePopUpClose}
          />
        ) : null}
        <div className="print" ref={printRef} style={{ display: "none" }}>
          <div className="printContent">
            <img
              src="https://d2nahbmqd5vvug.cloudfront.net/appdata/homealSideLogo.png"
              className="logoSize"
              alt="Homeal Logo"
            />

            <p className="printDetails">
              Order ID: <strong>{order?.orderID}</strong>
            </p>
            <p className="printDetails">
              Craver Name: <strong>{order?.craverDetails.craverName}</strong>
            </p>
            <p className="printDetails">
              Deliver By: <br />
              <strong>{order?.deliverBy}</strong>
            </p>

            <table style={{ width: "25%"}}>
              <thead>
                <tr>
                  <th className="mx-1">Qty</th>
                  <th>Item Name</th>
                </tr>
              </thead>
              <tbody>
                {order?.orderedItems.map((item, id) => (
                  <React.Fragment key={id}>
                    <tr>
                      <td className="mx-1" style={{ textAlign: "center" }}>{item.quantity}</td>
                      <td style={{ width: "80%"}}>
                        {item.menuName}
                        <br />
                        <span>({item.itemType})</span>
                        <br />
                        <span style={{display: "flex", flexWrap: "wrap" }}>{item.description}</span>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminTabs>
  );
};

export default Xpress;
